import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Main from 'layouts/Main';
import Container from 'components/Container';
import {
  About,
  Advantage,
  Features,
  Integrations,
  Reviews,
  Team,
  VideoSection,
} from './components';

import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-W1G8LXHX5C']
    })
  ]
})
const analyticsa = Analytics({
  app: 'awesome-app',
  plugins: [
    googleAnalytics({
      measurementIds: ['G-X34JYK01Q0']
    })
  ]
})
analytics.page()
analyticsa.page()

const alumini2023 = () => {
  const theme = useTheme();
  return (
    <Main><br/>
    <br/>
        <Container maxWidth={0.9} paddingTop={'0 !important'}>
          <Advantage/>
          <Reviews/>
          <Features />
        </Container>
        <Container maxWidth={0.9} paddingTop={'0 !important'}>
      
        </Container>
        <Container maxWidth={0.9} paddingTop={'0 !important'}>
          <About />
        </Container>
        

       
    </Main>
  );
};

export default alumini2023;
